<div class="confirmationDialog_container">
    <h1 mat-dialog-title>{{data.title}}</h1>
    <div mat-dialog-content class="confirmationDialog_message">
      {{data.message}}
    </div>
    <div class="confirmationDialog_actionsContainer">
      <button mat-raised-button class="confirmationDialog_button" (click)="onCancel()">{{data.cancelButtonText}}</button>
      <button mat-raised-button class="confirmationDialog_button confirmationDialog_button--confirm" (click)="onConfirm()">{{data.confirmButtonText}}</button>
    </div>
</div>
